import "./styles.css";
import { useEffect, useState } from "react";
import { app, /*executeDeepLink*/ } from "@microsoft/teams-js";
import axios from "axios";
import moment from "moment";
import "moment/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Activity, ActivityFilters } from "./types";
import { Loader } from "./components/Loader";
import { ActivityFilter } from "./components/ActivityFilter";
import { ActivityList } from "./components/ActivityList";

export default function App() {
  const { t, i18n } = useTranslation();
 
  const [activitiesByDate, setActivitiesByDate] = useState<Map<string, Activity[]>>(new Map());
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tenantId, setTenantId] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");

  const fromDate = moment().subtract(10, "days").startOf("day");
  const toDate = moment().endOf("day");

  const [filters, setFilters] = useState<ActivityFilters>({
    date_from: fromDate.toDate(),
    date_to: toDate.toDate(),
    my_activity: false
  });

  useEffect(() => {
    setIsLoading(true);

    // try {
    //   setTenantId('');
    //   setUserEmail('');
  
    //   i18n.changeLanguage('fr');
    //   moment.locale('fr');
    // } catch(error) {
    //   console.error("Error app.initialize:", error);
    // } finally {
    //   setIsInitialized(true);
    // }

    // setTimeout(() => {
    //   setIsInitialized(true);
    // }, 2000);

    app.initialize().then(async () => {
      const context = await app.getContext();
      setTenantId(context.user?.tenant?.id ?? "");
      setUserEmail(context.user?.loginHint ?? "");
      const locale = context.app.locale.substring(0, 2);
      i18n.changeLanguage(locale);
      moment.locale(locale);

      setIsInitialized(true);
    })
  }, [i18n]);

  useEffect(() => {
    const fetchActivities = async () => {
      setIsLoading(true);
      try {
        const params = new URLSearchParams({
          tenantId,
          userEmail,
          fromDate: filters.date_from.toISOString() ?? "",
          toDate: filters.date_to.toISOString() ?? "",
          myActivity: filters.my_activity.toString()
        });
  
        const response = await axios.get(`/api/activity?${params.toString()}`);
  
        const activitiesByDate = groupActivitiesByDate(response.data);
  
        setActivitiesByDate(activitiesByDate);
      } catch (error) {
        console.error("Error fetching activities:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (filters.date_from && filters.date_to && isInitialized && tenantId && userEmail) {
      fetchActivities();
    }
  }, [filters, isInitialized, tenantId, userEmail]);


  function handleFiltersChange(newFilters: Partial<ActivityFilters>) {
    setFilters((currentFilters) => ({ ...currentFilters, ...newFilters}));
  }

  function getPeriodText(dateFrom: any, dateTo: any) {
    let from = moment(dateFrom).year() === moment(dateTo).year() ?
      moment(dateFrom).format('D MMM') :
      moment(dateFrom).format('D MMM YYYY');
  
    let to = dateTo ? moment(dateTo).format('D MMM YYYY') : '';
  
    return t('period_from') + from + t('period_to') + to;
  }

  return (
    <>
      {isLoading || !isInitialized ? <Loader /> :
        <div className="activity">
          <div className="header row">
            <div className="col">
              <h2 className="title">
                {getPeriodText(filters.date_from, filters.date_to)}
              </h2>
            </div>
            <div className="col">
              <ActivityFilter filters={filters} onFiltersChange={handleFiltersChange}/>
            </div>
          </div>
          <ActivityList activitiesByDate={activitiesByDate} />
        </div>
      }
    </>
  );
}

function groupActivitiesByDate(activities: Activity[]) {
  let activitiesByDate = new Map<string, Activity[]>();

  activities.forEach((activity: Activity) => {
    const date = moment(activity.date).format("YYYY-MM-DD");

    if (!activitiesByDate.has(date)) {
      activitiesByDate.set(date, []);
    }

    activitiesByDate.get(date)?.push(activity);
  })

  return activitiesByDate;
}